import React, { memo } from "react";
import { number, string, oneOf } from "prop-types";

import style from "./style.module.scss";
import { formatPercent } from "./utils";

export default memo(MetricBar);

MetricBar.propTypes = {
  label: string,
  value: number,
  variant: oneOf(["match", "missing", "redundant"]),
};

function MetricBar({ label, value, variant }) {
  const width = Number.isFinite(value) ? Math.min(Math.max(value, 0), 100) : 0;

  return (
    <div className={style.metricRow}>
      <span className={style.metricLabel}>{label}</span>
      <div className={style.metricTrack}>
        <div
          className={`${style.metricFill} ${style[`metric_${variant}`]}`}
          style={{ width: `${width}%` }}
        />
      </div>
      <span className={style.metricValue}>{formatPercent(value)}</span>
    </div>
  );
}
